'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var RootContainer = styled__default.div(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  margin-top: 15px;\n"], ["\n  margin-top: 15px;\n"])));
var SelectContainer = styled__default.div(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  display: flex;\n  .MuiButtonBase-root {\n    width: 300px;\n    height: 36.6px;\n    justify-content: space-between;\n  }\n"], ["\n  display: flex;\n  .MuiButtonBase-root {\n    width: 300px;\n    height: 36.6px;\n    justify-content: space-between;\n  }\n"])));
var TitleContainer = styled__default.div(templateObject_3 || (templateObject_3 = tslib.__makeTemplateObject(["\n  color: ", ";\n  font-size: 14px;\n  margin-bottom: 10px;\n  font-weight: normal;\n"], ["\n  color: ", ";\n  font-size: 14px;\n  margin-bottom: 10px;\n  font-weight: normal;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.text.secondary;
});
var templateObject_1, templateObject_2, templateObject_3;

exports.RootContainer = RootContainer;
exports.SelectContainer = SelectContainer;
exports.TitleContainer = TitleContainer;
